import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "back-button-section" }
const _hoisted_3 = { class: "campaign-header" }
const _hoisted_4 = { class: "header-top" }
const _hoisted_5 = { class: "header-left" }
const _hoisted_6 = { class: "header-info" }
const _hoisted_7 = { class: "campaign-title" }
const _hoisted_8 = { class: "campaign-meta" }
const _hoisted_9 = { class: "meta-item" }
const _hoisted_10 = { class: "meta-item" }
const _hoisted_11 = { class: "meta-item" }
const _hoisted_12 = { class: "header-actions" }
const _hoisted_13 = { class: "two-column-layout" }
const _hoisted_14 = { class: "left-column" }
const _hoisted_15 = { class: "section-card" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "right-column" }
const _hoisted_18 = { class: "section-card" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = {
  key: 1,
  class: "no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_CampaniiForm = _resolveComponent("CampaniiForm")!
  const _component_ContactCampanii = _resolveComponent("ContactCampanii")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!

  return (_openBlock(), _createBlock(_component_DxScrollView, { class: "campaign-details-container" }, {
    default: _withCtx(() => [
      (_ctx.campaign)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DxButton, {
                icon: "arrowleft",
                text: "Înapoi la listă",
                "styling-mode": "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
                class: "back-btn"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "campaign-icon" }, [
                    _createElementVNode("i", { class: "dx-icon-box" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.campaign.Denumire || 'Campanie fără titlu'), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "dx-icon-event" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.campaign.DataStart)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.campaign.DataEnd)), 1)
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "meta-separator" }, "•", -1)),
                      _createElementVNode("span", _hoisted_10, [
                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "dx-icon-money" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.campaign.Buget)), 1)
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "meta-separator" }, "•", -1)),
                      _createElementVNode("span", _hoisted_11, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.campaign.Industrie?.Nume || _ctx.campaign.IndustrieNume || 'Fără industrie'), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['status-badge', _ctx.campaign.CurentActiv ? 'status-active' : 'status-inactive'])
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.campaign.CurentActiv ? 'Activ' : 'Inactiv'), 1)
                  ], 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", { class: "card-header-icon" }, [
                      _createElementVNode("i", { class: "dx-icon-doc" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Detalii Campanie")
                  ], -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_CampaniiForm, { "campaign-data": _ctx.campaign }, null, 8, ["campaign-data"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #10b981 0%, #34d399 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-group" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Contacte Asociate")
                  ], -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ContactCampanii, {
                      "campaign-id": _ctx.campaign.ID
                    }, null, 8, ["campaign-id"])
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("div", { class: "no-data-icon" }, [
              _createElementVNode("i", { class: "dx-icon-box" })
            ], -1),
            _createElementVNode("p", { class: "no-data-text" }, "Nicio campanie selectată", -1)
          ]))]))
    ]),
    _: 1
  }))
}